/**
 * @generated SignedSource<<ef943d0b0a08f2f66163d19d55e4ee01>>
 * @relayHash d936340f41c48ee7bf66a1c8df1804dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a11c5635f26e65e5bd11b333e2bcfd6e5c957e8b0ce4084e5fc2bde6de2fc04c

import type { ConcreteRequest } from 'relay-runtime';
export type usePerformanceInsightsAccessQuery$variables = Record<PropertyKey, never>;
export type usePerformanceInsightsAccessQuery$data = {
  readonly entitlements: {
    readonly performanceInsights: {
      readonly isEntitled: boolean;
    } | null;
  } | null;
};
export type usePerformanceInsightsAccessQuery = {
  response: usePerformanceInsightsAccessQuery$data;
  variables: usePerformanceInsightsAccessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "Entitlements",
    "kind": "LinkedField",
    "name": "entitlements",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluencePerformanceInsightsFeature",
        "kind": "LinkedField",
        "name": "performanceInsights",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEntitled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "usePerformanceInsightsAccessQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePerformanceInsightsAccessQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d936340f41c48ee7bf66a1c8df1804dd",
    "id": "a11c5635f26e65e5bd11b333e2bcfd6e5c957e8b0ce4084e5fc2bde6de2fc04c",
    "metadata": {},
    "name": "usePerformanceInsightsAccessQuery",
    "operationKind": "query",
    "text": "query usePerformanceInsightsAccessQuery{entitlements{performanceInsights{isEntitled}}}"
  }
};
})();

(node as any).hash = "174143f795f0a9245850edfb8435443f";

export default node;
